import React from "react";
import { Link } from "react-router-dom";
import config from "../coreFIles/config";

export default function ComingSoon() {
  const base = (config.baseUrl || "/").replace(/\/+$/, "") || "/";
  const loginPath = `${base}/login`.replace("//", "/");

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          
          <p className="auth-subtitle">We&apos;re preparing something new</p>
        </div>
        <div style={{ textAlign: "center", padding: "8px 0 20px" }}>
          <p style={{ fontSize: 22, fontWeight: 600, color: "var(--gray-800)", margin: "0 0 8px" }}>
            Coming soon
          </p>
          <p style={{ fontSize: 14, color: "var(--gray-500)", margin: 0, lineHeight: 1.5 }}>
            This area is not available yet. Please check back later.
          </p>
        </div>
        
      </div>
    </div>
  );
}
